import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class SaldoStockService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSegunId(empresa_rut, sucursal_codigo, bodega_codigo, codigo, callback) {
        const inputParams = {
            empresa_rut,
            sucursal_codigo,
            bodega_codigo,
            codigo
        };
        this.gqlclient.query({
            query: gql `
        query ($empresa_rut: Decimal, $sucursal_codigo:Decimal, $bodega_codigo:Decimal, $codigo: Decimal) {
          saldo_stock{
            obtenerSegunId(entidad:{rut_empresa:$empresa_rut, sucursal_codigo: $sucursal_codigo, bodega_codigo:$bodega_codigo, producto_codigo:$codigo, formato_codigo:"UNID"}){
              mensajes{
                codigo
                contexto
                texto
                tipo
              }
              respuesta{
                stock_disponible
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_stock.obtenerSegunId;
            callback({ mensajes, respuesta });
        });
    }
    reporteCalculoPedido(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: saldo_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_stock {
            reporteCalculoPedido(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  cant_vendida
                  monto_vendido
                  stock_actual
                  stock_sugerido
                  stock_difinitivo
                  formato_comb_cantidad
                  precio_costo
                  monto_pedido
                  total_calculo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_stock.reporteCalculoPedido;
            callback({ mensajes, respuesta });
        });
    }
    reporteCalculoPedidoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: saldo_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_stock {
            reporteCalculoPedido(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_stock.reporteCalculoPedido;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerTotalesReporte(inputParams, callback) {
        //console.log('ObtenerTotalesDocumento', JSON.stringify(inputParams))
        this.gqlclient.query({
            query: gql `
        query ($lista: [saldo_stockInputType]) {
          saldo_stock {
            totalCalculoPedido(lista: $lista) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                total_stock_actual
                total_pedido
                monto_pedido
                total_stock_siguiente
                total_calculo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_stock.totalCalculoPedido;
            callback({ mensajes, respuesta });
        });
    }
    reportePDFDetallePago(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: saldo_stockInputType) {
          saldo_stock {
            reportePDFCalculoPedido(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_stock.reportePDFCalculoPedido;
            callback({ mensajes, respuesta });
        });
    }
    obtenerStockProducto(inputParams, callback) {
        //console.log('ObtenerTotalesDocumento', JSON.stringify(inputParams))
        this.gqlclient.query({
            query: gql `
        query ($entidad: saldo_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_stock {
            stockProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes{
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  bodega_codigo
                  bodega_nombre
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  stock_disponible
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_stock.stockProducto;
            callback({ mensajes, respuesta });
        });
    }
}
SaldoStockService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SaldoStockService_Factory() { return new SaldoStockService(i0.ɵɵinject(i1.GraphQLClient)); }, token: SaldoStockService, providedIn: "root" });
